<mat-toolbar class="nav-container">
    <img src="bus-solid.svg" class="app-logo" alt="logo">
    <span class="app-name">Trans Digital</span>
    <span class="spacer"></span>
    <!-- <a class="nav-item" routerLink="/route-map" routerLinkActive="active">Route Map</a>
    <a class="nav-item" routerLink="/gtfs-builder" routerLinkActive="active">GTFS Builder</a> -->
</mat-toolbar>